export default { sha: '01a8e38f910ffabab49110467b839fc94a185c3b', buildNumber: 'undefined' }
